import React from 'react';
import PropTypes from 'prop-types';

import ContentContainer from './ContentContainer';
import PopUp from "./PopUp";
import Loading from "../elements/Loading";

export default class GameMaterialItem extends React.Component {
  static propTypes = {
    item: PropTypes.shape({}).isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      styles: {},
      icons: [],
      showPopUp: false,
    };
    this.renderTitle = this.renderTitle.bind(this);
    this.renderIcons = this.renderIcons.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.download = this.download.bind(this);
  }
  componentWillUnmount() {}
  handleClick() {
    return null;
  }
  renderTitle() {
    return <p>{this.props.item.title}</p>;
  }
  renderIcons() {
    return this.state.icons.map((icon, i) => {
      if (typeof icon === 'string') {
        return <img key={i} style={{ marginLeft: '10px' }} src={icon} alt="icon"/>;
      } else if (typeof icon === 'object') {
        return <img {...icon} key={i} style={{ marginLeft: '10px', ...icon.style }} src={icon.src} alt={'icon' || icon.alt}/>;
      }
      return null;
    });
  }
  download(ev = {}) {
    const { target } = ev;
    const { item } = this.props;
    if (target && target.tagName === 'IMG') {
      target.style.opacity = 0.5;
      target.style.pointerEvents = 'none';
    }
    if (!item.Material) return;
    window.open(item.Material.url, '_blank');
  }

  togglePopup = () => {
    this.setState({
      showPopUp: !this.state.showPopUp,
    })
  }

  render() {
    return (
      <ContentContainer onClick={this.props.disabled ? this.togglePopup : this.handleClick} style={this.state.styles} className={`${this.props.disabled ? 'disabled' : ''}`}>
        {this.renderTitle()}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          {this.renderIcons()}
        </div>
        { this.state.showPopUp ? (
          <PopUp popUpFooter={true} id={`m${this.props.gameState.difficulty === 'BASIC' ? 'l' : 'h'}bmfilmquiz_mobiel`} closePopUpClick={this.togglePopup}/>
        ) : null }
        {this.state.loading ? <Loading /> : null}
      </ContentContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/GameMaterialItem.js